import styled from 'styled-components';
import { PageContainer as Container } from '@/styles/Page';

export const PageContainer = styled(Container)`
  margin-top: 60px;

  display: flex;
  flex-direction: row;

  align-items: flex-start;
  max-width: 1360px;
  gap: 80px;

  margin-bottom: 80px;

  min-height: 65vh;

  @media (max-width: 1040px) {
    margin-top: 30px;
  }
`;
